import {
  Typography,
  Button,
  Icon,
  CircularLoader,
  Input,
} from "@plum-xoxo/admin-dsm";
import React, { useState, useEffect, useRef } from "react";
import styled from "styled-components";
import { makeRequestAuth } from "../../../utils/globals";
import { Turnstile } from "@plum-xoxo/turnstile_captcha";
import { TURNSTILE_SITE_KEY } from "../../../constants/AppConstant";
import { NotificationManager } from "react-notifications";

const StyledInput = styled(Input)`
  input {
    background-color: ${(props) => props.theme.palette.light.c000};
  }
`;

const StyledButton = styled(Button)`
  :hover {
    background-color: transparent;
  }
`;

const VerifyOtpScreen = ({ email, UID, setCurrentStep, showCts }) => {
  let timer_id = "";

  const [otp, setotp] = useState("");
  const [resendClicked, setResendClicked] = useState(false);
  const [countdown, setCountdown] = useState(0);
  const [otpError, setOtpError] = useState("");
  const [renderTurnstileCaptcha, setRenderTurnstileCaptcha] = useState(false);
  const [loader, setLoader] = useState(false);

  const onComplete = () => {
    if (otp.length < 6) return;

    setLoader(true);
    const ValidateOtpPromise = new Promise((resolve, reject) => {
      const query = "diy.mutation.validate_otp_plum_diy";
      const request_data = {
        query,
        tag: "diy",
        variables: {
          email: email,
          OTP: otp,
          diy_uuid: UID,
        },
      };

      makeRequestAuth(
        request_data,
        (response) => {
          if (response) resolve(response);
          reject(0);
        },
        {},
        "/api/public/graph"
      );
    });

    ValidateOtpPromise.then((response) => {
      const data = response?.data?.validateOTPUser;
      if (data?.success === 1) {
        setCurrentStep(2);
      } else {
        if (
          data?.errmsg &&
          data?.errmsg ==
            "You have entered wrong code multiple time, we are unable to verify your email"
        )
          setOtpError(data?.errmsg);
        else setOtpError("You have entered incorrect code.");
        setotp("");
      }
    })
      .catch((e) => {
        NotificationManager.error("Something went wrong");
      })
      .finally(() => {
        setLoader(false);
      });
  };

  const handleResendClick = (token) => {
    setOtpError("");
    setRenderTurnstileCaptcha(false);
    resendOtp(token);
    setCountdown(60);
    timer_id = setInterval(() => {
      setCountdown((p) => {
        if (p < 1) {
          setResendClicked(false);
          clearInterval(timer_id);
        }
        return p - 1;
      });
    }, 1000);
  };

  const resendOtp = (token = "") => {
    setLoader(true);
    const query = "diy.mutation.resend_diy_store_otp";
    const request_data = {
      query,
      tag: "diy",
      variables: {
        email: email,
        diy_uuid: UID,
        token,
      },
    };

    makeRequestAuth(
      request_data,
      (response) => {
        setLoader(false);
        if (response?.data?.resendDIYStoreOtp?.success === 1) {
          // do nothing
        } else {
          setResendClicked(false);
          NotificationManager.error(
            (response.data.resendDIYStoreOtp &&
              response.data.resendDIYStoreOtp.errmsg) ||
              "Something Went Wrong"
          );
        }
      },
      {},
      "/api/public/graph"
    );
  };

  useEffect(() => {
    if (otp.length === 6) {
      onComplete();
      return;
    }
    if (otp.length !== 0) {
      setOtpError("");
    }
  }, [otp]);

  return (
    <div className="d-flex flex-column w-100">
      <div>
        <Typography.H1>Verify your email</Typography.H1>
        <Typography className="mt-6">
          We have sent a 6-digit confirmation code to your email address {email}
          . Enter it below.
        </Typography>
      </div>
      <StyledInput
        autoFocus={true}
        value={otp}
        onChange={(e) => {
          let pattern = /^\d+$/;
          if (pattern.test(e.target.value) && e.target.value.length < 7)
            setotp(e.target.value);
          else if (e.target.value == "") setotp(e.target.value);
        }}
        className="mt-16 mb-8"
        type={"text"}
        placeholder="Enter code"
        error={otpError ? true : false}
      />

      {countdown > 0 && resendClicked && !otpError && !loader && (
        <Typography.BodySmall
          color="green"
          shade="c300"
          component="div"
          className="d-flex gap-8"
        >
          <Icon
            color="green"
            shade="c300"
            iconName="Right"
            size={20}
            className="mb-16"
          />
          A new code has been sent to your email address.
        </Typography.BodySmall>
      )}
      {otpError && (
        <Typography.BodySmall color="red" shade="c200" className="mb-4">
          {otpError}
        </Typography.BodySmall>
      )}
      <div className="d-flex align-items-center justify-content-between">
        {renderTurnstileCaptcha ? (
          <Turnstile
            siteKey={TURNSTILE_SITE_KEY}
            options={{ theme: "light" }}
            onSuccess={(token) => handleResendClick(token)}
          />
        ) : (
          <>
            {resendClicked ? (
              <StyledButton variant="plain" className="p-0" disabled>
                Resend OTP in {countdown} seconds...
              </StyledButton>
            ) : (
              <StyledButton
                variant="plain"
                className="px-0"
                onClick={() => {
                  if (showCts) {
                    setRenderTurnstileCaptcha(true);
                  } else {
                    handleResendClick();
                  }
                  setResendClicked(true);
                }}
              >
                Resend Code
              </StyledButton>
            )}
          </>
        )}
        {loader ? (
          <CircularLoader className="mr-24" />
        ) : (
          <StyledButton
            variant="plain"
            onClick={() => setCurrentStep(0)}
            className="px-0"
          >
            Change Email Address
          </StyledButton>
        )}
      </div>
      <Typography.BodySmall className="mt-48">
        Didn't receive email? Check your spam folder.
      </Typography.BodySmall>
    </div>
  );
};

export default VerifyOtpScreen;
